import { Divider } from 'antd';

import styles from './StepIntro.module.scss';
import { BookingComOption } from './_components/BookingComOption';
import { ChannelManagerOption } from './_components/ChannelManagerOption';
import { StepIntroHeader } from './_components/StepIntroHeader';

type StepIntroProps = {
  onSelectChannelManager: () => void;
  onSelectBookingCom: () => void;
};

export const StepIntro = ({
  onSelectChannelManager,
  onSelectBookingCom,
}: StepIntroProps) => (
  <div className={styles.stepIntro}>
    <StepIntroHeader />
    <Divider className={styles.divider} />
    <div className={styles.options}>
      <ChannelManagerOption onClick={onSelectChannelManager} />

      <div className={styles.optionDivider} />

      <BookingComOption onClick={onSelectBookingCom} />
    </div>
  </div>
);
